import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import EmployeeCreation from './EmployeeCreation';
import LeadManagement from '../LeadManagementNew/LeadManagement'
import "./_userManagement.scss"


class UserManagement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            blockType: "2"
        }
    }
    render() {
        return (
            <Container className='UserManagement'>
                {/* <div className='d-flex justify-content-end mr-2'>
                    <div>
                        <button className={this.state.blockType == "2" ? "active block_view_User_Details02" : "block_view_User_Details02"} onClick={() => this.setState({ blockType: "2" })}>EMPLOYEE CREATION</button>
                    </div>
                    <div className='ml-1'>
                        <button className={this.state.blockType == "3" ? "active block_view_User_Details02" : "block_view_User_Details02"} onClick={() => this.setState({ blockType: "3" })}>LEAD MANAGEMENT</button>
                    </div>
                </div> */}
                {/* <Row>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        {
                            this.state.blockType == "2" ? <EmployeeCreation globals={this.props.globals} /> : ""
                                this.state.blockType == "3" ? < LeadManagement globals={this.props.globals} /> : ""
                        }
                    </Col>
                </Row> */}
            </Container>
        )
    }
}

export default UserManagement